
import { computed, defineComponent } from 'vue';
import { useStore } from '@/store';
import Button from 'primevue/button';
import { AlertSeverity, BillingAlert } from '@/types/billing-types';

export default defineComponent({
  name: 'AlertBanner',

  components: { Button },

  emits: ['cta'],

  setup() {
    const store = useStore();
    const alerts = computed<BillingAlert[]>(() => (
      store.state.billing.overview?.alerts ?? []
    ));

    const iconFor = (s: AlertSeverity) => {
      if (s === 'danger') return 'fa-regular fa-circle-exclamation';
      if (s === 'warning') return 'fa-regular fa-triangle-exclamation';
      return 'fa-regular fa-circle-info';
    };

    return { alerts, iconFor };
  },
});
